import { colorFamilyToTokenBorderColor } from '../../utils/color/legacyColorFamily';
import { deepMerge } from '../../utils/deepMerge';
const DEFAULT_BACKGROUND_COLOR = 'fill-brand-default';
const backgroundColorMapping = Object.assign({}, colorFamilyToTokenBorderColor, {
  // we are intentionally using colorFamilyToTokenBorderColor rather than colorFamilyToTokenBackgroundColor because it aligns closely to the legacy badge color mapping
  /**
   * Overrides
   */
  calypso: 'temp-do-not-use-fill-secondary-default',
  'candy-apple': 'fill-alert-default',
  lorax: DEFAULT_BACKGROUND_COLOR,
  oz: 'fill-positive-default',
  /**
   * Custom
   */
  beta: 'fill-accent-purple-default',
  new: 'fill-positive-default'
});
const addBorderRadiusCornerValue = ({
  theme,
  styles,
  borderRadiusKey,
  cornerRadius,
  borderRadius
}) => {
  // Default to the overall borderRadius if individual values are undefined
  const value = cornerRadius !== null && cornerRadius !== void 0 ? cornerRadius : borderRadius;
  if (value) {
    styles[borderRadiusKey] = theme.borderRadius[value];
  }
};
export const getBackgroundColorToken = use => {
  var _backgroundColorMappi;
  return (_backgroundColorMappi = backgroundColorMapping[use]) !== null && _backgroundColorMappi !== void 0 ? _backgroundColorMappi : DEFAULT_BACKGROUND_COLOR;
};
export const getBadgeStyleOverrides = ({
  use,
  theme,
  borderRadius,
  borderStartStartRadius,
  borderStartEndRadius,
  borderEndStartRadius,
  borderEndEndRadius,
  badgeContext
}) => {
  var _badgeContext$badgeSt;
  const styles = {};
  addBorderRadiusCornerValue({
    theme,
    styles,
    borderRadiusKey: 'borderStartStartRadius',
    cornerRadius: borderStartStartRadius,
    borderRadius
  });
  addBorderRadiusCornerValue({
    theme,
    styles,
    borderRadiusKey: 'borderStartEndRadius',
    cornerRadius: borderStartEndRadius,
    borderRadius
  });
  addBorderRadiusCornerValue({
    theme,
    styles,
    borderRadiusKey: 'borderEndStartRadius',
    cornerRadius: borderEndStartRadius,
    borderRadius
  });
  addBorderRadiusCornerValue({
    theme,
    styles,
    borderRadiusKey: 'borderEndEndRadius',
    cornerRadius: borderEndEndRadius,
    borderRadius
  });
  return deepMerge(Object.assign({}, use !== 'count' ? styles : {}), (_badgeContext$badgeSt = badgeContext === null || badgeContext === void 0 ? void 0 : badgeContext.badgeStyleOverrides) !== null && _badgeContext$badgeSt !== void 0 ? _badgeContext$badgeSt : {});
};